import React from 'react';
import { useLocation } from 'react-router-dom';
import DetectTouch from '../partials/utils/DetectTouch';
import ViewportFix from '../partials/utils/ViewportFix';
import Cover from '../partials/global/Cover';
import Header from '../partials/global/Header';
import Dot from '../partials/global/Dot';
import Page from '../partials/page/Page';
import Project from '../partials/project/Project';
import { StoreProvider } from '../context/Context';

const TplIndex = () => {
    const location = useLocation();
    
    // Determine which component to render based on route
    const renderContent = () => {
        const pathname = location.pathname;
        
        if (pathname.startsWith('/project/')) {
            return <Project />;
        } else if (pathname === '/' || pathname.startsWith('/')) {
            return <Page />;
        }
        
        return null;
    };

    const content = renderContent();

    if (!content) {
        return null;
    }

    return (
        <StoreProvider>
            <DetectTouch />
            <ViewportFix />
            <Cover />
            <Header />
            <Dot />
            {content}
        </StoreProvider>
    );
};

export default TplIndex;